const store = {
    token: 'gestauto/token',
    userId: 'gestauto/userid',
    userName: 'gestauto/username',
    userCpjCnpj: 'gestauto/usercpfcnpj',
    userEmail: 'gestauto/useremail',
    userTelefone: 'gestauto/usertelefone',
    // [SECURITY] flag espelhada do users.force_password_change do backend.
    // Quando '1', RequireFreshPassword redireciona toda navegacao
    // protegida para /alterar-senha ate o usuario trocar.
    forcePasswordChange: 'gestauto/forcepwd',
}

export default { store }